<template>
  <div class="home">
    <div>
      <!-- Image and text -->
      <b-navbar toggleable="lg" class="fixed-top pr-0 pt-0 pb-0 mb-5">
        <b-navbar-brand>
          <img src="../assets/ICDL_bleu_sans_marge.png" />
        </b-navbar-brand>
        <b-navbar-toggle target="nav_collapse">
          <span class="navbar-toggler-icon" />
        </b-navbar-toggle>
        <b-collapse id="nav_collapse" is-nav>
          <b-navbar-nav :class="`ml-auto  align-items-center h-100 pl-3`">
            <li class="nav-item d-flex align-items-center mr-3">
              <a>
                <b-icon icon="link45deg"></b-icon>
                <br>
                Le site ICDL
              </a>
            </li>
            <li class="nav-item d-flex align-items-center mr-3">
              <a>
                <b-icon icon="film"></b-icon><br>
                {{ $t("menu.demo") }}
              </a>
            </li>

          </b-navbar-nav>

        </b-collapse>

      </b-navbar>



      <div class="logged-out pt-5">
        <div v-if="is_loaded && !is_submitted">
          <div class="d-flex justify-content-center align-items-center mt-5">
            <b-card title="Parcours d'évaluation" class="text-center col-lg-12 mb-3">
              <b-card-text>
                Votre centre habilité ICDL vous permet de sélectioner les tests d'évaluation que vous souhaitez passer.
              </b-card-text>
              <b-button :disabled="(selectedMessaging != null && selectedBrowser == null) || (selectedMessaging == null && selectedBrowser != null)" class="icdl-blue" @click="submitParcours">Valider les tests sélectionnés</b-button>
            </b-card>
          </div>
          <div class="d-flex justify-content-center align-items-center ">


            <div class="accordion mt-5 col-lg-10" role="tablist">
              <b-card no-body v-for="(module,index) in modules" class="mb-1" :key="index">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block v-b-toggle="'accordion-'+index" @click="toggleOpenedAccordion(index)" class="icdl-blue btn-lg">{{module.label}} <span v-if="module.isAdvanced"> - niveau avancé</span><b-icon-caret-up-square v-if="isOpenedAccordion(index)" class="ml-2"></b-icon-caret-up-square><b-icon-caret-down-square v-else class="ml-2"></b-icon-caret-down-square></b-button>
                </b-card-header>
                <b-collapse :id="'accordion-'+index" :accordion="'accordion-'+index" role="tabpanel">
                  <b-card-body>
                    <b-row v-if="module.sub_modules">
                      <div class="container-fluid">
                        <b-alert show class="col-lg-12">Vous devez sélectionner un navigateur et un logiciel de messagerie</b-alert>
                      </div>
                      <b-row class="container-fluid">
                        <h4>Navigateurs</h4>
                      </b-row>
                      <b-row  class="container-fluid">
                        <b-col v-for="(browser,indexBrowser) in module.sub_modules.browser"  lg="4" :key="indexBrowser" class="mt-2">
                          <b-card no-body :class="{'pt-2':true,'success':selectedMessaging != null,'warning':selectedMessaging == null,selected: isSelectedBrowser(browser.id)}">
                            <div>
                              <h5><b-avatar class="mr-2 mb-2" :src="api+browser.image.file_name"></b-avatar>{{browser.name}}</h5>
                              <b-button v-if="isSelectedBrowser(browser.id)" block class="icdl-blue card-btn" @click="unselectBrowser(browser.id)"><b-icon-dash-circle></b-icon-dash-circle> Désélectionner</b-button>
                              <b-button v-else block class="icdl-blue card-btn" @click="selectBrowser(browser.id)"><b-icon-plus-circle></b-icon-plus-circle> Sélectionner</b-button>
                            </div>
                          </b-card>
                        </b-col>
                      </b-row>
                      <b-row  class="container-fluid mt-2">
                        <h4>Messagerie</h4>
                      </b-row>
                      <b-row  class="container-fluid">
                        <b-col v-for="(messaging,indexMessaging) in module.sub_modules.messaging"  lg="4" :key="indexMessaging" class="mt-2">
                          <b-card no-body :class="{'pt-2':true,'success':selectedBrowser != null,'warning':selectedBrowser == null,'selected': isSelectedMessaging(messaging.id)}">
                            <div>
                              <h5><b-avatar class="mr-2 mb-2" :src="api+messaging.image.file_name"></b-avatar>{{messaging.name}}</h5>
                              <b-button v-if="isSelectedMessaging(messaging.id)" block class="icdl-blue card-btn" @click="unselectMessaging(messaging.id)"><b-icon-dash-circle></b-icon-dash-circle> Désélectionner</b-button>
                              <b-button v-else block class="icdl-blue card-btn" @click="selectMessaging(messaging.id)"><b-icon-plus-circle></b-icon-plus-circle> Sélectionner</b-button>
                            </div>
                          </b-card>
                        </b-col>
                      </b-row>
                    </b-row>
                    <b-row v-else>
                      <b-col v-for="(test,indexTest) in module.tests"  lg="4" :key="indexTest" class="mt-2">
                        <b-card no-body :class="{'pt-2':true,selected: isSelected(test.id) }">
                          <div>
                            <h5><b-avatar class="mr-2 mb-2" :src="api+test.image.file_name"></b-avatar>{{formatLabel(module.isAdvanced,test.label)}}</h5>
                            <b-button v-if="isSelected(test.id)" block class="icdl-blue card-btn" @click="unselectTest(test.id)"><b-icon-dash-circle></b-icon-dash-circle> Désélectionner</b-button>
                            <b-button v-else block class="icdl-blue card-btn" @click="selectTest(test.id)"><b-icon-plus-circle></b-icon-plus-circle> Sélectionner</b-button>
                          </div>
                        </b-card>
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>

            </div>

          </div>
        </div>
        <div v-else-if="is_loaded && is_submitted" class="pt-5">
          <b-alert  show variant="success">Votre inscription a bien été prise en compte.<br>
            <span v-if="validation == 'auto'">
              Un email vous permettant de vous connecter à la plateforme candidat ICDL vous a été envoyé.
            </span>
            <span v-else>
              Un email vous permettant de vous connecter à la plateforme candidat ICDL vous sera envoyé quand votre centre habilité ICDL aura validé votre inscription.
            </span>

          </b-alert>
        </div>
        <div v-else-if="!is_loaded">
          <div class="text-center">
            <b-card>
              <b-spinner label="Spinning" class="icdl-blue-inverse"></b-spinner>
              <b-card-text>
                Chargement des données
              </b-card-text>
            </b-card>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

    import axios from 'axios';
    import { BIcon, BIconPlusCircle,BIconDashCircle,BIconCaretUpSquare,BIconCaretDownSquare } from 'bootstrap-vue'
    export default {
        name: 'ParcoursView',
        components: {
            BIcon,
            BIconPlusCircle,
            BIconDashCircle,
            BIconCaretUpSquare,
            BIconCaretDownSquare
        },
        props: {
            form_link: {
                type: String,
                default:null
            },
            id_user: {
                type: String,
                default:null
            },
            validation: {
                type: String,
                default:null
            },
        },

        data(){
            return{
                id_site:null,
                id_formlink:null,
                is_formlink_valid: false,
                access_token:null,
                token_timestamp:0,
                is_loading:true,
                modules: null,
                api:process.env.VUE_APP_API_URL_IMAGE,
                selectedTests: [],
                selectedBrowser: null,
                selectedMessaging: null,
                is_submitted: false,
                is_loaded: false,
                openedAccordions: [],
            }
        },
        methods:{
            toggleOpenedAccordion(index){

              if(this.openedAccordions.includes(index)){
                  this.openedAccordions.splice(this.openedAccordions.indexOf(index),1)
              }
              else{
                  this.openedAccordions.push(index);
              }
            },
            isOpenedAccordion(index){
                console.debug(this.openedAccordions);
              return this.openedAccordions.includes(index);
            },
            submitParcours(){
                var parcoursData = {};
                parcoursData.tests = this.selectedTests;
                if(this.selectedBrowser != null)
                {
                    parcoursData.browser = this.selectedBrowser;
                }
                if(this.selectedMessaging != null)
                {
                    parcoursData.messaging = this.selectedMessaging;
                }
                console.debug(parcoursData);
                let headers = {"Authorization": 'Bearer ' + localStorage.access_token};
                axios
                    .post(process.env.VUE_APP_API_URL+'/formlink/'+this.id_user+'/parcours', parcoursData,{"headers":headers})
                    .then((response) => {
                        localStorage.access_token = response.data.access_token;
                        localStorage.token_timestamp = Date.now();
                        this.is_submitted = true;
                    })
            },
            formatLabel(isModuleAdvanced,testLabel){
              if(isModuleAdvanced){
                  let arrayLabel = testLabel.split(" - ");
                  return arrayLabel[0];
              }
              else{
                  return testLabel;
              }
            },
            isSelected(idTest){
                return this.selectedTests.includes(idTest)
            },
            selectTest(idTest){
                this.selectedTests.push(idTest)
            },
            unselectTest(idTest){
              this.selectedTests.splice(this.selectedTests.indexOf(idTest),1)
            },
            isSelectedBrowser(idTest){
                return this.selectedBrowser == idTest
            },
            selectBrowser(idTest){
                this.selectedBrowser = idTest;
            },
            unselectBrowser(idTest){
                this.selectedBrowser = null;
            },
            isSelectedMessaging(idTest){
                return this.selectedMessaging == idTest;
            },
            selectMessaging(idTest){
                this.selectedMessaging = idTest;
            },
            unselectMessaging(idTest){
                this.selectedMessaging = null;
            },
            checkCenter(){
                if(this.form_link != null)
                {
                    let headers = {"Authorization": 'Bearer ' + localStorage.access_token};
                    axios
                        .get(process.env.VUE_APP_API_URL + '/formlink/'+this.form_link,{"headers":headers})
                        .then((response) => {
                            let formlink = response.data.shift();
                            localStorage.id_site = parseInt(formlink.id_site);
                            localStorage.id_formlink = parseInt(formlink.id);
                            this.is_formlink_valid = true;
                            this.is_loading = false;
                        }).catch(()=> {
                        localStorage.id_site = null;
                        localStorage.id_formlink = null;

                        this.is_loading = false;
                    });
                }
                else{
                    this.is_loading = false;
                }
            },
            getAccessToken(){
                axios
                    .post(process.env.VUE_APP_API_URL+'/oauth/v2/token', {
                        "client_id": process.env.VUE_APP_CLIENT_ID,
                        "client_secret": process.env.VUE_APP_CLIENT_SECRET,
                        "grant_type": process.env.VUE_APP_GRANT_TYPE
                    })
                    .then((response) => {
                        localStorage.access_token = response.data.access_token;
                        localStorage.token_timestamp = Date.now();
                    })
            }
        },
        mounted(){
            if (localStorage.access_token) {
                this.access_token = localStorage.access_token;
            }
            if (localStorage.token_timestamp) {
                this.token_timestamp = localStorage.token_timestamp;
            }
            if (localStorage.id_site) {
                this.id_site = localStorage.id_site;
            }
            if (localStorage.id_formlink) {
                this.id_formlink = localStorage.id_formlink;
            }
            if(this.form_link != null)
            {
                if(this.access_token == null || this.token_timestamp + 3600000 > Date.now())
                {
                    this.getAccessToken();
                    this.checkCenter();
                }
                else{
                    this.checkCenter();
                }
            }
            else{
                this.is_loading = false;
            }

            let headers = {"Authorization": 'Bearer ' + localStorage.access_token};
            axios
                .get(process.env.VUE_APP_API_URL + '/formlink/tests/',{"headers":headers})
                .then((response) => {
                    this.modules = response.data.modules;
                });
            axios
                .get(process.env.VUE_APP_API_URL + '/formlink/'+this.id_formlink+'/parcours',{"headers":headers})
                .then((response) => {
                    let parcours = response.data[0];
                    let selectedTests = [];
                    let selectedBrowser = null;
                    let selectedMessaging = null;
                    parcours.forEach(function(test){
                       if(test.submodules)
                       {
                           selectedBrowser = test.submodules.browser;
                           selectedMessaging = test.submodules.messaging;
                       }
                       else{
                           selectedTests.push(test.id);
                       }
                    });
                    this.selectedTests = selectedTests;
                    this.selectedBrowser = selectedBrowser;
                    this.selectedMessaging = selectedMessaging;
                    this.is_loaded = true;
                });



        }
    }
</script>
<style>
  .list-group-item{
    padding: 0!important;
  }
  .b-avatar-img{
    background-color: #ffffff;
    border-radius:unset !important;
  }
  .rounded-circle{
    border:none !important;
  }
  .badge-secondary{
    border:none !important;
  }
  .card-btn{
    border-top-left-radius: 0 !important;
    border-top-right-radius: 0 !important;
  }
  .selected{
    border-color: #28a745 !important;
    border-width: 0.125rem !important;
  }
  .card.selected.success{
    border-color: #28a745 !important;
    border-width: 0.125rem !important;
  }
  .card.selected.warning{
    border-color: #ffc107 !important;
    border-width: 0.125rem !important;
  }
</style>
